'use client'

import { createContext, type FC, type ProviderProps, useContext } from 'react'

const WebviewContext = createContext(false)

export const WebviewContextProvider: FC<ProviderProps<boolean>> = (props) => (
  <WebviewContext.Provider {...props} />
)

export const useWebviewContext = (): boolean => useContext(WebviewContext)
